import { lazy } from "react";
import Loadable from "app/components/Loadable";
import { authRoles } from "../../../auth/authRoles";

const DeedsTable = Loadable(lazy(() => import("../deeds/App")));
const RecentLawTable = Loadable(lazy(() => import("../recent-case-law/App")));
const HotOffersTable = Loadable(lazy(() => import("../hot-offers/App")));
const SubscriptionTable = Loadable(lazy(() => import("../subscription/App")));
const SubscribeTable = Loadable(lazy(() => import("../subscribe/App")));

const ContentTable = Loadable(lazy(() => import("../legal-content/App")));

const directTaxRoutes = [
  { path: "/deeds", element: <DeedsTable />, auth: authRoles.guest},
  { path: "/deeds/:id/*", element: <DeedsTable />, auth: authRoles.guest },
  { path: "/recent-law", element: <RecentLawTable />, auth: authRoles.guest},
  { path: "/recent-law/:id/*", element: <RecentLawTable />, auth: authRoles.guest },
  { path: "/hot-offers", element: <HotOffersTable />, auth: authRoles.guest},
  { path: "/subscription", element: <SubscriptionTable />, auth: authRoles.guest},
  { path: "/subscribe", element: <SubscribeTable />, auth: authRoles.guest},
  { path: "/content/:slug/*", element: <ContentTable />, auth: authRoles.guest},

];

export default directTaxRoutes;
